import React, { useState } from 'react';
import MainLayout from '../../components/MainLayout';
import { Box, Typography, Tabs, Tab, useMediaQuery, Stack } from '@mui/material';
import prospectEmptyIcon from '../../assets/prospect_empty_icon.svg';
import SecondaryButton from '../../components/SecondaryButton';
import PastTourCard from '../../components/home/PastTourCard';
import { PastTour } from '../../types/tours';

const TAB_OPTIONS = [
  { label: 'Toured', value: 'toured' },
  // TODO: Uncomment when tabs are ready and we have the data
  // { label: 'Applied', value: 'applied' },
  // { label: 'Opt-outs', value: 'opt-outs' },
];

interface ProspectsProps {
  past_tours: PastTour[];
  customer_timezone: string;
}

const Prospects: React.FC<ProspectsProps> = ({ past_tours, customer_timezone }) => {
  const [tab, setTab] = useState(0);
  const isDesktop = useMediaQuery('(min-width: 600px)');

  // For now, just log the data to verify
  console.log('Past tours:', past_tours);

  const headerButton = (
    <SecondaryButton sx={{ fontWeight: 800, fontSize: 16, color: '#171717' }}>
      Edit screening
    </SecondaryButton>
  );

  return (
    <MainLayout headerText={null} headerButton={null}>
      {/* Sub-tabs */}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        aria-label="prospects sub-tabs"
        textColor="inherit"
        TabIndicatorProps={{ style: { background: '#171717', height: 2 } }}
        sx={{ mb: 2, width: '100%', maxWidth: 500 }}
      >
        {TAB_OPTIONS.map((option, idx) => (
          <Tab
            key={option.value}
            label={<span style={{ fontWeight: tab === idx ? 700 : 500, color: '#171717' }}>{option.label}</span>}
            sx={{ minWidth: 0, px: isDesktop ? 4: 2.5, textTransform: 'none', fontSize: 17 }}
          />
        ))}
      </Tabs>
      {/* Main content */}
      {TAB_OPTIONS[tab].value.toLowerCase() === 'toured' ? (
        past_tours.length > 0 ? (
          <Box sx={{ width: '100%', maxWidth: 500, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', mt: 2 }}>
            <Box sx={{ width: '100%' }}>
              <Stack spacing={2} alignItems="center">
                {past_tours.map((tour) => (
                  <PastTourCard key={tour.id} past_tour={tour} />
                ))}
              </Stack>
            </Box>
          </Box>
        ) : (
          <Box sx={{ width: '100%', maxWidth: 500, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: isDesktop ? 6 : 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, textAlign: 'left', ml: 0 }}>
              Prospects who came and toured will appear here.
            </Typography>
            <Typography sx={{ color: '#222', ml: 0, fontSize: 16, mb: 4, textAlign: 'left', maxWidth: 400, mt: 0 }}>
              Everything in one place.
            </Typography>
            <img src={prospectEmptyIcon} alt="No Prospects" style={{ width: isDesktop ? 180 : 120, margin: '0 auto' }} />
          </Box>
        )
      ) : (
        <Box sx={{ width: '100%', maxWidth: 500, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: isDesktop ? 6 : 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, textAlign: 'left', ml: 0 }}>
            Prospects who came and toured will appear here.
          </Typography>
          <Typography sx={{ color: '#222', ml: 0, fontSize: 16, mb: 4, textAlign: 'left', maxWidth: 400, mt: 0 }}>
            Everything in one place
          </Typography>
          <img src={prospectEmptyIcon} alt="No Prospects" style={{ width: isDesktop ? 180 : 120, margin: '0 auto' }} />
        </Box>
      )}
    </MainLayout>
  );
};

export default Prospects;